
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"367","height":"216","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"366.261","height":"216","rx":"7","fill":"#27E96A"}}),_c('path',{attrs:{"d":"M299.557 121.833v-27.72c0-3.054-2.57-5.561-5.761-5.561h-5.76c-3.163 0-5.761-2.48-5.761-5.56V52.516c0-3.053-2.57-5.56-5.761-5.56h-63.142c-3.191 0-5.761 2.48-5.761 5.56v30.501c0 3.053-2.569 5.561-5.76 5.561h-5.761c-3.163 0-5.761 2.48-5.761 5.56v27.749c0 3.053-2.569 5.56-5.76 5.56h-11.494c-3.162 0-5.76-2.48-5.76-5.56V94.112c0-3.053-2.57-5.56-5.761-5.56h-28.663c-3.162 0-5.76-2.48-5.76-5.56V55.27c0-3.053-2.57-5.56-5.761-5.56H89.799c-3.163 0-5.76 2.48-5.76 5.56v27.748c0 3.053-2.57 5.561-5.761 5.561H49.587c-3.191-.027-5.76 2.453-5.76 5.533v30.502c0 3.052 2.569 5.56 5.76 5.56h28.747c3.163 0 5.76 2.481 5.76 5.561v27.748c0 3.053 2.57 5.561 5.761 5.561h31.6c3.162 0 5.76-2.481 5.76-5.561v-27.776c0-3.052 2.57-5.56 5.761-5.56h25.782c3.163 0 5.761 2.48 5.761 5.56v27.749c0 3.053 2.57 5.56 5.761 5.56h31.599c3.163 0 5.761-2.48 5.761-5.56v-27.749c0-3.052 2.569-5.56 5.76-5.56h14.374c3.163 0 5.761-2.481 5.761-5.561V94.112c0-3.053 2.57-5.56 5.76-5.56h11.494c3.162 0 5.76 2.48 5.76 5.56v30.502c0 3.052 2.57 5.56 5.761 5.56h14.374c3.162 0 5.76 2.481 5.76 5.561v27.748c0 3.053 2.57 5.561 5.761 5.561h31.599c3.163 0 5.761-2.481 5.761-5.561v-30.556c0-3.053-2.57-5.56-5.761-5.56h-14.486c-3.163.027-5.761-2.454-5.761-5.534zm-175.278-24.94v24.968c0 3.052-2.57 5.56-5.761 5.56H92.679c-3.162 0-5.76-2.48-5.76-5.56V96.892c0-3.052 2.57-5.56 5.76-5.56h25.867c3.163 0 5.733 2.48 5.733 5.56z","fill":"#fff"}})])
          )
        }
      }
    